/**
 * Questionnaire validation utilities for context-specific input validation
 */

const BIRTH_CONTROL_PATTERNS = [
  // Standard variations
  "birth control",
  "birthcontrol",
  "birth-control",
  // Common typos
  "brith control", // swapped letters
  "birth contol", // missing r
  "birth controle", // extra e
  "burth control", // u instead of i
  "borth control", // o instead of i
  "birt control", // missing h
  "birth cotrol", // missing n
  "birth conrol", // missing t
  // Real ingredient/brand names -- see docs/specs/medication-search-input.md's
  // B12 clause for rationale and sign-off status.
  "norethindrone",
  "ethinyl estradiol",
  "levonorgestrel",
  "drospirenone",
  "yaz",
  "yasmin",
  "ortho tri-cyclen",
  "loestrin",
  "nexplanon",
];

/**
 * Detects if the input mentions birth control in generic terms
 * @param input - User input text to validate
 * @returns true if birth control is mentioned, false otherwise
 */
export function includesBirthControl(input: string): boolean {
  if (!input || typeof input !== "string") {
    return false;
  }

  const normalized = input.toLowerCase().trim();

  // Check standard patterns
  const hasStandardPattern = BIRTH_CONTROL_PATTERNS.some((pattern) =>
    normalized.includes(pattern)
  );

  // Check for "bc" abbreviation using word boundaries
  // Matches: "BC", "Aspirin, BC", "BC.", "take BC daily"
  // Avoids: "abc", "tuberculosis", "abcdefg"
  const bcPattern = /\bbc\b/i;
  const hasBcAbbreviation = bcPattern.test(input);

  return hasStandardPattern || hasBcAbbreviation;
}
